import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { bankLabel, paymentLabel } from "./finance";
import { formatDate, formatMoney } from "./format";

const money = (value) => (Number(value) ? formatMoney(value) : "—");

const fileSafe = (value) =>
  String(value || "statement")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 60);

export function downloadStatementPdf({ title, subtitle, kind, from, to, rows, totals }) {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const now = new Date();
  const period =
    from || to
      ? `${from ? formatDate(from) : "Start"} to ${to ? formatDate(to) : "Today"}`
      : "All dates";

  doc.setFillColor(20, 61, 44);
  doc.rect(0, 0, pageWidth, 28, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Builder Books", 14, 12);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${kind} statement`, 14, 20);
  doc.text(now.toLocaleDateString("en-GB"), pageWidth - 14, 12, { align: "right" });
  doc.text(now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }), pageWidth - 14, 20, {
    align: "right",
  });

  doc.setTextColor(20, 20, 20);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text(title || "Statement", 14, 40);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  if (subtitle) doc.text(String(subtitle), 14, 46);
  doc.text(`Period: ${period}`, 14, subtitle ? 52 : 46);

  autoTable(doc, {
    startY: subtitle ? 58 : 52,
    head: [["Date", "Particulars", "Type", "Debit", "Credit", "Balance"]],
    body: (rows || []).map((row) => [
      formatDate(row.date),
      [row.particulars, bankLabel(row.bank), row.referenceNumber].filter(Boolean).join(" · ") || "—",
      paymentLabel(row.paymentType),
      money(row.debit),
      money(row.credit),
      formatMoney(row.balance),
    ]),
    theme: "plain",
    foot: [
      [
        "",
        "Totals",
        "",
        formatMoney(totals?.debit),
        formatMoney(totals?.credit),
        formatMoney(totals?.balance),
      ],
    ],
    styles: {
      font: "helvetica",
      fontSize: 8,
      cellPadding: 2.2,
      textColor: [32, 32, 32],
      lineColor: [220, 220, 220],
      lineWidth: 0.2,
      overflow: "linebreak",
    },
    headStyles: {
      fillColor: [245, 242, 232],
      textColor: [80, 80, 80],
      fontStyle: "bold",
      fontSize: 8,
    },
    footStyles: {
      fillColor: [245, 242, 232],
      textColor: [20, 20, 20],
      fontStyle: "bold",
    },
    columnStyles: {
      0: { cellWidth: 28 },
      1: { cellWidth: 62 },
      2: { cellWidth: 24 },
      3: { cellWidth: 24, halign: "right" },
      4: { cellWidth: 24, halign: "right" },
      5: { cellWidth: 26, halign: "right" },
    },
    didDrawPage: () => {
      const page = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.setTextColor(120, 120, 120);
      doc.text(`Page ${page}`, pageWidth / 2, doc.internal.pageSize.getHeight() - 8, { align: "center" });
    },
  });

  doc.save(`${fileSafe(title)}-statement.pdf`);
}
